/** @format */

import { Input } from "antd";
import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { SearchOutlined } from "@ant-design/icons";

import pdf from "../../../icons/pdf.png";
import print from "../../../icons/print.png";
import excel from "../../../icons/excel.png";
import { ExcelPrint, Pdf } from "../../../components/functions/Print";

const tableData = [
  ["Respublikasi bo‘yicha jami"],
  ["JMK tranzitidan tashqari Arnasoy s.o."],
  ["Amudaryo havzasi bo‘yicha jami"],
  ["Qoraqalpog‘iston Respublikasi Suv xo‘jaligi vazirligi"],
  ["Qoraqalpog‘iston Respublikasi"],
  ["Chapqirg‘oq Amudaryo ITHB"],
  ["Shu jumladan"],
  ["Xorazm viloyati"],
  ["Amu-Qashqadaryo ITHB"],
  ["Shu jumladan"],
  ["Qashqadaryo viloyati"],
  ["Amu-Buxoro ITHB"],
  ["Shu jumladan"],
  ["Buxoro viloyati"],
  ["Quyi-Zarafshan ITHB"],
  ["Navoiy viloyati"],
].map((name, idx) => [idx + 1, name, 400, 2.9, 1296, 2.9, 1296, 53]);

const Table22 = () => {
  const componentPDF = useRef();

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "Statistik hisobotlar",
  });

  return (
    <>
      <div className='table-content-top'>
        <div className='table-top-left'>
          <Input
            prefix={<SearchOutlined className='site-form-item-icon' />}
            placeholder='Search'
          />
        </div>

        <ul className='table-top-right'>
          <li>
            <button className='btn p-0' onClick={generatePDF}>
              <img src={print} alt='print' />
            </button>
          </li>

          <li>
            <button onClick={() => Pdf("tblData")} className='btn p-0'>
              <img src={pdf} alt='pdf' />
            </button>
          </li>

          <li>
            <button
              className='btn p-0'
              onClick={() =>
                ExcelPrint("Statistik hisobotlar", "sheet 1", "tblData")
              }>
              <img src={excel} alt='excel' />
            </button>
          </li>
        </ul>
      </div>

      <div className='table-responsive tableFixHead'>
        <div ref={componentPDF} style={{ width: "100%" }}>
          <table id='tblData' className='table table-bordered table-style'>
            <thead>
              <tr>
                <th rowSpan={3}>№</th>
                <th colSpan={7}>
                  2 bo‘lim. Cuv manbalaridan maʼmuriy hududlar bo‘yicha
                  foydalanilgan suv to‘g‘risida hisobot.
                </th>
              </tr>

              <tr>
                <th rowSpan={2}>
                  Respublika, irrigatsiya tizimlari havza boshqarmalari va
                  viloyatlar
                </th>
                <th rowSpan={2}></th>
                <th rowSpan={2}></th>
                <th colSpan={4}>Shu jumladan</th>
              </tr>

              <tr>
                <th>Daryo o‘zanidan</th>
                <th>Ichki soy va daryolardan</th>
                <th>Yer osti suvlaridan</th>
                <th>Zovurlar dan</th>
              </tr>
            </thead>

            <tbody>
              {tableData.map((row, i) => (
                <tr key={i}>
                  <th>{row[0]}</th>
                  <th>{row[1]}</th>
                  <td>{row[2]}</td>
                  <td>{row[3]}</td>
                  <td>{row[4]}</td>
                  <td>{row[5]}</td>
                  <td>{row[6]}</td>
                  <td>{row[7]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default Table22;
